// extracted by mini-css-extract-plugin
export var buttons = "index-module--buttons--a0d03";
export var contentWrapper = "index-module--contentWrapper--add1c";
export var ctaContainer = "index-module--ctaContainer--154dc";
export var ctaTitle = "index-module--ctaTitle--1efdf";
export var intro = "index-module--intro--8e3c6";
export var list = "index-module--list--8df72";
export var listItem = "index-module--listItem--f4d5b";
export var listItemDescription = "index-module--listItemDescription--ab61c";
export var listItemLink = "index-module--listItemLink--66995";
export var mainText = "index-module--mainText--601be";
export var ourPropositionsHover = "index-module--ourPropositionsHover--91120";
export var recentNewsBar = "index-module--recentNewsBar--92509";
export var scrollText = "index-module--scrollText--5c86a";
export var scrollingText = "index-module--scrollingText--f8967";
export var subText = "index-module--subText--a04d7";
export var textCenter = "index-module--textCenter--fd035";
export var textStyle = "index-module--textStyle--1a11d";
export var wrapperHome = "index-module--wrapperHome--c2249";